import React from "react";
import { Box, Typography, FormControl, Select, MenuItem } from "@mui/material";
import FlagIcon from "@mui/icons-material/Flag";
import { ESTADOS_OPTIONS } from "../../constants";

/**
 * Sección de estado de la incidencia (editable o solo lectura)
 */
const SeccionEstado = ({ estado, puedeEditar, loading, onChange }) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        variant="body2"
        sx={{
          fontWeight: 600,
          mb: 1,
          color: "#495057",
          fontSize: 13,
          display: "flex",
          alignItems: "center",
          gap: 0.5,
        }}
      >
        <FlagIcon sx={{ fontSize: 18 }} />
        Estado
      </Typography>
      {puedeEditar ? (
        <FormControl fullWidth>
          <Select value={estado} onChange={onChange} disabled={loading}>
            {ESTADOS_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value.toString()}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : (
        <Typography sx={{ fontSize: 14, color: "#212529" }}>
          {ESTADOS_OPTIONS.find((e) => e.value.toString() === estado)?.label ||
            "Sin estado"}
        </Typography>
      )}
    </Box>
  );
};

export default SeccionEstado;
